import { useSelector } from "react-redux";

import DialogBox from "../../../components/UI/DialogBox";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import spin from "../../../assets/icons/spin.png";
import { USER_DISABLE_LIST } from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import DisableUserContainer from "../components/disableUsers/DisableUserContainer";

const DisableUsersPage = () => {
  const { isLoaded } = useFetchData(USER_DISABLE_LIST);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.count : 0;

  return (
    <MainPageLayout headerConfig={{ title: "Disabled Users" }} numberOfData={dataLength} bgColor="bg-dBlue-100">
      {isLoaded && !error ? (
       <DisableUserContainer />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default DisableUsersPage;
